enum OrientationAxis {
  AXIAL = 'axial',
  CORONAL = 'coronal',
  SAGITTAL = 'sagittal',
  ACQUISITION = 'acquisition',
  AXIAL_REFORMAT = 'axial_reformat',
  CORONAL_REFORMAT = 'coronal_reformat',
  SAGITTAL_REFORMAT = 'sagittal_reformat',
  REFORMAT = 'reformat',
}

export default OrientationAxis;
